import { render, staticRenderFns } from "./PassRecoveryNotif.vue?vue&type=template&id=b207d70a&scoped=true"
import script from "./PassRecoveryNotif.vue?vue&type=script&lang=js"
export * from "./PassRecoveryNotif.vue?vue&type=script&lang=js"
import style0 from "./PassRecoveryNotif.vue?vue&type=style&index=0&id=b207d70a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b207d70a",
  null
  
)

export default component.exports